import { withUtf8Bom } from '@/lib/export/csv'

/** Trigger a file download in the browser (call from client components only). */
export function triggerCsvDownload(filename: string, csvBody: string, options?: { useBom?: boolean }) {
  if (typeof window === 'undefined') return
  const useBom = options?.useBom !== false
  const payload = useBom ? withUtf8Bom(csvBody) : csvBody
  const blob = new Blob([payload], { type: 'text/csv;charset=utf-8' })
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = filename.replace(/[^\w.\-]+/g, '_')
  a.rel = 'noopener'
  document.body.appendChild(a)
  a.click()
  a.remove()
  URL.revokeObjectURL(url)
}
